import { APP_INITIALIZER, LOCALE_ID, NgModule } from '@angular/core';
import { BrowserModule, Title } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { CommonModule, registerLocaleData } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { HTTP_INTERCEPTORS, HttpBackend, HttpClient, HttpClientModule } from '@angular/common/http';
import { RouterModule } from '@angular/router';
// ServiceWorkerModule removido - usando Service Worker nativo via PushNotificationService
import { environment } from '../environments/environment';

//Routes
import { routes } from './app.route';

import { AppComponent } from './app.component';

// store
import { StoreModule } from '@ngrx/store';
import { indexReducer } from './store/index.reducer';

// shared module
import { SharedModule } from 'src/shared.module';

// i18n
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
// AOT compilation support
export function HttpLoaderFactory(httpHandler: HttpBackend): TranslateHttpLoader {
    return new TranslateHttpLoader(new HttpClient(httpHandler));
}

// pages
import { KnowledgeBaseComponent } from './pages/knowledge-base';
import { FaqComponent } from './pages/faq';

// Layouts
import { AppLayout } from './layouts/layout/app-layout';
import { AuthLayout } from './layouts/auth-layout/auth-layout';

import { HeaderComponent } from './layouts/header/header';
import { FooterComponent } from './layouts/footer/footer';
import { SidebarComponent } from './layouts/sidebar/sidebar';
import { ThemeCustomizerComponent } from './layouts/theme-customizer/theme-customizer';
import { AppService } from './services';
import { appInitializerFactory } from './app-init.factory';
import { AuthInterceptor } from './auth/services/auth.interceptor';
import { OfflineInterceptor } from './core/interceptors/offline.interceptor';
import { authReducer } from './auth/store/auth.reducer';
import { UserDropdownComponent } from './layouts/header/components/user-dropdown/user-dropdown.component';
import { ModalConfirmationComponent, ConfirmationFeedbackComponent, OfflineIndicatorComponent, NotificationsComponent } from './shared/components/index';
import { SocketStatusComponent } from './components/socket-status/socket-status.component';
import { LocationDisclosureComponent } from './shared/components/location-disclosure';

@NgModule({
    imports: [
        RouterModule.forRoot(routes, { scrollPositionRestoration: 'enabled' }),
        BrowserModule,
        BrowserAnimationsModule,
        CommonModule,
        FormsModule,
        HttpClientModule,
        TranslateModule.forRoot({
            loader: {
                provide: TranslateLoader,
                useFactory: HttpLoaderFactory,
                deps: [HttpBackend],
            },
        }),
        StoreModule.forRoot({
            auth: authReducer,
            index: indexReducer,
        }),
        // ServiceWorker agora é gerenciado diretamente pelo PushNotificationService
        // usando push-sw.js (sem dependência do Angular ServiceWorkerModule)
        SharedModule.forRoot(),
        OfflineIndicatorComponent,
        ModalConfirmationComponent,
        ConfirmationFeedbackComponent,
        SidebarComponent,
        NotificationsComponent,
        SocketStatusComponent,
        LocationDisclosureComponent,
    ],
    declarations: [
        AppComponent,
        FooterComponent,
        ThemeCustomizerComponent,
        AppLayout,
        AuthLayout,
        KnowledgeBaseComponent,
        FaqComponent,
        // layout components
        HeaderComponent,
        UserDropdownComponent,
    ],

    providers: [
        Title,
        AppService,
        { provide: LOCALE_ID, useValue: 'pt-BR' },
        {
            provide: APP_INITIALIZER,
            useFactory: appInitializerFactory,
            deps: [AppService],
            multi: true,
        },
        {
            provide: HTTP_INTERCEPTORS,
            useClass: AuthInterceptor,
            multi: true,
        },
        {
            provide: HTTP_INTERCEPTORS,
            useClass: OfflineInterceptor,
            multi: true,
        },
    ],
    bootstrap: [AppComponent],
})
export class AppModule { }
